"use client";

import React, { useEffect, useLayoutEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";
import { Icon } from "@iconify/react";

import styles from "./courses.module.scss";
import Components from "@/components";
import useApi from "@/hooks/useApi";
import sk from "@/skeletons";
import api from "@/api";

function Categories(props) {
  const { data: popularCtg, request: loadpopularCtg } = useApi(api.category);

  const [catPerView, setCatPerView] = useState(1.75);
  const [gap, setGap] = useState(10);

  function windowHandler() {
    // Minimum width infinite, Maximum width fixed
    if (window.innerWidth <= 1000) {
      setGap(25);
    }
    if (window.innerWidth <= 700) {
      setGap(20);
      setCatPerView(2.75);
    }
    if (window.innerWidth <= 500) {
      setCatPerView(1.75);
      setGap(15);
    }
    if (window.innerWidth <= 400) {
      setCatPerView(1.75);
      setGap(10);
    }
    // Minimum width fixed, Maximum width infinite
    if (window.innerWidth > 700) {
      setCatPerView(Math.ceil(window.innerWidth / 300));
    }
    if (window.innerWidth > 1000) {
      setGap(30);
    }
  }

  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    windowHandler();
    window.addEventListener("resize", windowHandler);
    return () => window.removeEventListener("resize", windowHandler);
  }, []);

  useEffect(() => {
    loadpopularCtg();
  }, []);

  return (
    <article className={`${styles["hm-category-rows"]} ${props.className}`}>
      <div
        className={`${styles["hm-category-videos"]} ${styles["categories"]} ${
          !popularCtg?.data?.length ? styles["loading"] : ""
        } `}
      >
        <button className={`${styles["prev"]}`} id="Ctg_Left_Arrow">
          <Icon icon={"mdi:arrow-left"} />
        </button>
        {popularCtg?.data?.length ? (
          <Swiper
            slidesPerView={catPerView}
            spaceBetween={gap}
            freeMode={true}
            pagination={false}
            navigation={{
              prevEl: "#Ctg_Left_Arrow",
              nextEl: "#Ctg_Right_Arrow",
            }}
            modules={[FreeMode, Navigation]}
            className={styles["category-swiper"]}
          >
            {popularCtg?.data?.map((ctg, i) => (
              <SwiperSlide key={i}>
                <Components.CategoryCard
                  category={ctg}
                  toggleLoginModal={props.toggleLoginModal}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <sk.RowCardSkeleton
            number={Math.ceil(catPerView)}
            type="sk-category-card"
          />
        )}
        <button className={`${styles["next"]}`} id="Ctg_Right_Arrow">
          <Icon icon={"mdi:arrow-right"} />
        </button>
      </div>
    </article>
  );
}

export default Categories;
